export default {
   
  farm: {
    nationalFarmId: "ID Nacional de Finca",
    locationType: "Tipo de Ubicación",
    viewLocation: "Ver Ubicación",
    Circular: "Circular",
    Polygon: "Polígono",
    farmActivities: "Actividades de la granja",
    scheduledActivities: "Actividades programadas",
    completedActivities: "Actividades completadas",
    listView: "Vista de lista",
    calendarView: "Vista de calendario",
    search: "Buscar",
    filterByFarmName: "Filtrar por nombre de la granja",
    filterByCropType: "Filtrar por tipo de cultivo",
    filterByStartDate: "Filtrar por fecha de inicio",
    cropName: "Nombre del cultivo",
    Name: "Nombre",
    activities: "Actividades",
    startDate: "Fecha de inicio",
    endDate: "Fecha de término",
    activityDetails: "Detalles de la actividad",
    selectFarmToEnableCalenderView: 'Seleccione la granja para habilitar la vista de calendario',
    id: "identificación",
    locationName: "Nombre de la ubicación",
    createdAt: "Creado en",
    etherScanLink: "Enlace de blockchain",
    overallProb: "Probabilidad general",
    farmerId: "ID del Agricultor",
    farmAddress: "Dirección de la Ubicación de la Finca",
    farmID: "ID de la Finca",
    farmIdPlaceHolder: "Ingrese el ID de la Finca",
    onTheFarm: "En la Finca",
    userRoles: "Roles de Usuario",
    adduser: "Agregar Usuario",
    addAuser: "Agregar un Usuario",
    uploadUsers: "Subir Usuarios",
    addNewUser: "Agregar Nuevo Usuario",
    selectDept: "Seleccionar Departamento",
    selectRole: "Seleccionar Rol",
    editUser: "Editar Usuario",
    totalFarms: "Fincas Totales",
    NoAnimalsRegisteredForthisFarm:
      "No hay Animales Registrados para esta Finca",
    farmsPerPage: "Fincas por Página",
    radius: "Radio",
    radiusInfo: "Especifica la distancia desde un punto central hasta el borde exterior de un área circular.",
    radiusUnitInfo: "Se refiere a una cantidad estándar utilizada como base para la medición.",
    regularFarms: "Fincas Regulares",
    farmRegisteredProducts: "Productos Registrados de la Finca",
    searchByFarmNameAndId: "Buscar por Nombre de la Finca e ID",
    loadingProductsPleaseWait: "Cargando Productos... Por favor espera",
    farmName: "Nombre de la Finca",
    nameOfTheFarm: "Nombre de la Finca",
    farmLocation: "Ubicación de la Finca",
    productName: "Nombre del Producto",
    stockStatus: "Estado del Inventario",
    inStock: "En Inventario",
    searchByProductName: "Buscar por Nombre del Producto",
    productCategory: "Categoría del Producto",
    products: "Productos",
    download: "Descargar",
    of: "de",
    previousPage: "Página Anterior",
    nextPage: "Página Siguiente",
    view: "Ver",
    activity: "Actividad",
    cropType: "Tipo de Cultivo",
    description: "Descripción",
    close: "Cerrar",
    deforestationReports: "Informe(s) de Deforestación",
    farms: "Fincas",
    zones: "Zonas",
    registerAfarm: "Registrar una Finca",
    govtRegistry: "Registro del Gobierno",
    cooperativeId: "ID de Cooperativa/Unión",
    cooperativeName: "Nombre de Cooperativa/Unión",
    factory: "Fábrica",
    farmType: "Tipo de Finca",
    contractMating: "Emparejamiento por Contrato",
    customization: "Personalización",
    recordsPerpage: "Registros por Página",
    restoreDefault: "Restaurar Configuración Predeterminada",
    apply: "Aplicar",
    CommunityName: "Nombre de la Comunidad",
    corporateName: "Nombre Corporativo",
    corporateRegistrationNum: "Número de Registro Corporativo",
    corporateMailingAddress: "Dirección de Correo Corporativo",
    communityName: "Nombre de la Comunidad",
    searchState:
      "Buscar por ID de Finca, Registro del Gobierno, ID de Cooperativa, Tipo de Finca, Emparejamiento por Contrato",
    farmOwner: "Dueño de la Finca",
    govRegistrationNo: "Número de Registro del Gobierno",
    farmInformation: "Información de la Finca",
    ownershipType: "Tipo de Propiedad",
    farmLicenseInformation: "Información de Licencia de la Finca",
    licenseNumber: "Número de Licencia",
    licenseExpiryDate: "Fecha de Vencimiento de la Licencia",
    regulatorName: "Nombre del Regulador",
    regulatorRepresentativeName: "Nombre del Representante del Regulador",
    farmLocationSize: "Ubicación y Tamaño de la Finca",
    productionSystem: "Sistema de Cultivo",
    productionSystemNew: "Sistema de Producción",
    goals: "Objetivo(s)",
    country: "País",
    state: "Estado",
    city: "Ciudad/Pueblo",
    gpsLocation: "Ubicación GPS",
    latitude: "Latitud",
    longitude: "Longitud",
    farmNumber: "Número de la Finca",
    postal: "Código Postal",
    houseNumber: "Número de Casa",
    farmRegistration: "Registro de la Finca",
    cancel: "Cancelar",
    register: "Registrar",
    ok: "Aceptar",
    totalFarmSize: "Tamaño Total de la Finca",
    farmGeographicLocation: "Ubicación Geográfica de la Finca",
    perimeterPointLongitude: "Longitud del Punto de Perímetro",
    perimeterPointLatitude: "Latitud del Punto de Perímetro",
    perimeterPointLabel: "Etiqueta del Punto de Perímetro",
    perimeterLength: "Longitud del Perímetro",
    farmLatitude: "Latitud de la Finca",
    farmLongitude: "Longitud de la Finca",
    editFarm: "Editar Finca",
    update: "Actualizar",
    editAfarm: "Editar una Finca",
    nextFarm: "Siguiente Finca",
    nameoftheFarm: "Nombre de la Finca",
    addNewLocation: "Agregar Nueva Ubicación",
    registerAProduct: "Registrar un Producto",
    farmProducts: "Productos de la Finca",
    calf: "Ternero",
    steer: "Novillo",
    heifer: "Vaquilla",
    sire: "Padre",
    dam: "Madre",

    registerAnAnimal: "Registrar un Animal",
    farmAnimals: "Animales de la Finca",
    farm_type: "Tipo de Finca",
    farm_Owner: "Dueño de la Finca",
    dateOfRegistration: "Fecha de Registro",
    dataIsNotAvailableForThisFarm: "No hay Datos Disponibles para esta Finca",
    registerNewProduct: "Registrar un Nuevo Producto",
    information: "Información",
    licenseInfo: "Información de la Licencia",
    locationInfo: "Información de la Ubicación",
    geoLocation: "Ubicación Geográfica",
    perimeterLengthState:
      "Longitud del Perímetro de la Finca (longitud de la cerca)",
    totalFarmSizeState: "Tamaño de una Finca",
    productionSystemState: "Sistema de Producción utilizado en la Finca",
    contractMatingState:
      "Código del Programa de Emparejamiento por Contrato en el que la Finca Participa",
    ownershipTypeState: "Tipo de Propiedad",
    regulatorRepresentativeNameState:
      "Nombre de la persona que representa al regulador que emitió la licencia",
    regulatorNameState: "Nombre del regulador que emitió la licencia",
    licenseExpiryDateState: "Fecha en que vence la licencia actual",
    licenseNumberState: "Número de licencia emitido por el regulador",
    plotNumberState: "Número de la casa de la Finca",
    plotNumber: "Número de la Finca",
    streetStatement: "Nombre de la calle de la Finca",
    cityStatement: "Ciudad donde se encuentra la Finca",
    farmLocationAddressInfo:
      "El lugar donde la Finca realiza su actividad agrícola principal.",

    provinceStateInfo:
      "Una división administrativa principal de un país o imperio.",
    cityInfo:
      "Un asentamiento humano o comunidad agrupada y los edificios asociados, más grande que un caserío y más pequeño que una ciudad, situado en una zona rural.",
    streetNumberInfo: "Número de la Calle",
    totalFarmSizeInfo: "Tamaño Total de la Finca",
    areaUOMInfo:
      "Unidad de medida para el tamaño de la Finca, por ejemplo, hectárea, acre, etc.",
    perimeterLengthInfo: "Perímetro Total de la Finca",
    permiterUOMInfo:
      "Unidad de medida para el perímetro de la Finca, por ejemplo, centímetro, metro, etc.",

    stateStatement: "Región del país donde se encuentra la Finca.",
    countryState: "País donde se encuentra la Finca.",
    farmStateInfo: "Dirección de la ubicación de la Finca",
    perimeterPointLongitudeState: "Longitud de un punto en la Finca.",
    perimeterPointLatitudeState: "Latitud de un punto en la Finca.",
    perimeterPointLabelState: "Etiqueta del Punto.",
    farmLongitudeState: "Longitud de la Finca.",
    farmLatitudeState: "Latitud de la Finca.",
    deleteFarm: "Eliminar Finca",
    confirmBulkDeleteFarm:
      "¿Seguro que desea eliminar {count} granja(s) seleccionada(s)?",
    selectFarmsToDelete: "Seleccione al menos una granja para eliminar.",
    bulkDeleted: "Se han eliminado {count} granja(s).",

    farmNameH: "Nombre de la Finca",
    farmTypeH: "El tipo de Finca donde se realizan diferentes actividades.",
    farmOwnerH:
      "Nombre del propietario de una Finca (generado automáticamente al ingresar la información)",
    ownershipTypeH:
      "El tipo de agricultores que poseen/controlan la tierra que cultivan y aquellos que no lo hacen.",
    govtRegNumbH: "Número de registro de la Finca asignado por el regulador",
    contractMatingH:
      "Código del programa de empadronamiento por contrato en el que participa la Finca",
    productionSystemH: "Sistema de producción utilizado en la Finca",
    cooperativeIDH: "ID de una cooperativa a la que pertenece la Finca",
    licenseNumberH:
      "Número de identificación en una licencia emitida por el regulador que la identifica con el propietario.",
    licenseExpiryDateH: "Fecha en que vence la licencia actual",
    regularNameH: "Nombre del regulador que emitió la licencia",
    regularRepName:
      "Nombre de la persona que representa al regulador que emitió la licencia",
    countryH: "País donde se encuentra la Finca.",
    stateH: "Región del país donde se encuentra la Finca.",
    cityH: "Ciudad donde se encuentra la Finca.",
    streetH: "Nombre de la calle de la Finca.",
    houseNumberH: "Número de la casa de la Finca.",
    totalFarmSizeH:
      "El tamaño de la Finca es la suma de la tierra actualmente cultivada por la Finca, incluida la tierra en barbecho pero excluyendo la tierra bajo vegetación natural, árboles o pastos.",
    farmLatitudeH:
      "Es la medida de la distancia al norte o al sur del ecuador. Se mide con 180 líneas imaginarias que forman círculos alrededor de la Tierra de este a oeste, paralelas al ecuador.",
    farmLongitudeH:
      "Mide la distancia al este u oeste del meridiano principal.",
    perimeterLengthH:
      "Longitud del perímetro de la Finca (longitud de la cerca)",
    perimeterPointLabelH:
      "Etiqueta del punto. Usando tres parámetros (latitud, longitud y etiqueta) describimos el perímetro de la Finca y cualquier segmento dentro de la Finca.",
    perimeterPointLatH: "Latitud de un punto en la Finca",
    perimeterPointLongH: "Longitud de un punto en la Finca",
    street: "Calle",
    registration: {
      regulatorName: "Nombre del regulador que emitió la licencia",
      perimeterPointLabel:
        "Etiqueta del punto. Usando tres parámetros (latitud, longitud y etiqueta) describimos el perímetro de la Finca y cualquier segmento dentro de la Finca.",
      perimeterPointLatitude: "Latitud de un punto de perímetro",
      perimeterPointLongitude: "Longitud de un punto de perímetro",
      farmID: "Número de Identificación asignado a la Finca de ganado",
      farmName: "Nombre asignado a la Finca de ganado",
      CommunityName:
        "Nombre dado a un grupo de personas con una característica o interés común que viven juntas dentro de una sociedad más grande",
      farmType:
        "El tipo de Finca se puede clasificar (agrupar) según el ganado cultivado y cómo se cultiva",
      farmOwner:
        "Cualquier persona que posea o controle las operaciones de una Finca",
      ownershipType:
        "El tipo de agricultores que poseen/controlan la Finca y aquellos que no lo hacen",
      govtRegistrationNumber:
        "Número dado por la organización gubernamental en la que está registrada la Finca",
      licenseNumber: "Número de licencia emitido por el regulador",
      licenseExpiryDate:
        "Día en que la licencia se vuelve inválida para su reconocimiento",
      regulatorRepresentativeName: "Nombre del Representante del Regulador",
    },
    addFarm: "Agregar Finca",
    farmerFirstName: "Primer Nombre del Agricultor",
    farmerMiddleName: "Segundo Nombre del Agricultor",
    farmerLastName: "Apellido del Agricultor",
    iAmNotFarmer: "No soy el Agricultor",
    certifications: "Certificaciones",
    productionType: "Tipo de Producción",
    deleted: "Finca eliminada exitosamente.",
    notDeleted: "Finca no eliminada.",

    
    farmTitleDocument: "Documentos de título de la granja",
    technicianName: "Nombre del técnico",
    regBy: "Registrado por",
    regDate: "Fecha de registro",
    farmRegistrationId: "ID de registro de la granja",
    farmerRegistrationId: "ID de registro del agricultor",
    farmId: "ID de la granja",
    farmerName: "Nombre del agricultor",
    farmOwnershipType: "Tipo de propiedad agrícola",
    farmGoals: "Objetivos de la granja",
    farmCertifications: "Certificaciones agrícolas",
    farmInfo: "Información de la granja",
    provinceState: "Provincia/Estado",
    streetNumber: "Número de calle",
    addGeofenceForThisFarm: "Agregar geovalla para esta granja",
    pleaseClickToChooseLocation: "Por favor, haga clic para elegir la ubicación",
    address: "Dirección",
    geographicLocation: "Ubicación geográfica",
    searchLocation: "Buscar ubicación",
    pleaseChooseOneOfTheOption: "Por favor elija una de las opciones",
    useGeoFencingFeature: "Utilizar la función de geovalla",
    uploadShapeFile: "Subir un archivo de forma",
    uploadGeofence: "Subir geovalla",
    upload: "Subir",
    reports: "Informes",
    generateReport: "Generar informe",
    avocado: "Aguacate",
    avocadoTrees: "Árboles de aguacate",
    addNewFarmLocation: "Agregar nueva ubicación de la granja",
    farmLocationAddress: "Dirección de la ubicación de la granja",
    useGeofenceTool: "Usar herramienta de geovalla",
    geofenceIsRequiredForSatelliteReport: "Nota: La geovalla es requerida para informes satelitales",
    enterHere: "Ingresar aquí",
    primaryLocation: "Ubicación principal",
    secondaryLocation: "Ubicación secundaria",
    locationAndSize: "Ubicación y tamaño",
    farmReports: "Informe(s)",
    addNewZone: "Agregar nueva zona",
    noZoneMessage: "No se ha registrado ninguna zona todavía.",
    noZoneRequest: "Por favor, haga clic en Agregar nueva zona para crear una zona para esta granja.",
    locationZone: "Zona de ubicación",
    editFarmLocation: "Editar ubicación de la granja",
    addZone: "Agregar zona",
    nameOfTheZone: "Nombre de la zona",
    zoneDetails: "Detalles de la zona",
    perimeter: "Perímetro",
    areaUnit: "Unidad de área",
    area: "Área",
    zoneName: "Nombre de la zona",
    farmGeofence: "Geovalla de la granja",
    circularGeofence: "Geovalla circular",
    polygonGeofence: "Geovalla poligonal",
    actions: "Acciones",
    editZone: "Editar zona",
    numberOfGroups: "Número de grupos",
    numberOfTrees: "Número de árboles",
    group: "Grupo",
    groupName: "Nombre del grupo",
    numberOfAnimals: "Número de animales",
    status: "Estado",
    primaryGeofence: "Geovalla principal",
    walkAndMeasure: "Caminar y medir",
    clearGeofence: "Borrar geovalla",
    deleteSelectedVertex: "Eliminar vértice seleccionado",
    basicInformation: "Información básica",
    geofenceCategoryName: "Nombre de la categoría de geovalla",
    geofenceName: "Nombre de la geovalla",
    farmRadius: "Radio de la granja",
    locationDisabledMessage: "Su ubicación está deshabilitada. Por favor, busque su ubicación desde los menús de la izquierda.",
    yourDistanceIs: "Su distancia es",
    selectFarmToEnableCalendarView: "Por favor seleccione una granja para habilitar la vista del calendario",
    noFarm: "No se ha registrado ninguna granja todavía.",
    noFarmDescription: "Por favor, haga clic en los botones a continuación para comenzar.",

    serachFarmName: "Buscar por Nombre de la Finca",
    pleaseSelectFarmType: "Por favor seleccione el tipo de Finca",
    dropHere: "o arrastrar y soltar aquí",

    "organic": "Orgánico",
  "conventional": "Convencional",
  importFarmsInBulk: "Importar granjas en masa",
  importFarms: "Importar granjas",
  importingNote: "Su archivo subido está siendo procesado.\nNo haga clic en cancelar, cerrar o actualizar esta página para evitar interrupciones.",
  bulkImportNote: "Descargue y use las plantillas a continuación para importar granjas en bloque.",
  importCompleted: "Importación completada",
  importantNote: "Nota importante",
  selectFileToUpload: "Seleccione el archivo para cargar los datos",
  importantNoteDetail:  "Utilice las plantillas proporcionadas anteriormente para cargas masivas. Otros formatos resultarán en fallos.",
  searchFarmName: "Buscar nombre de granja",
  
  farmsAccessControl: "Control de Acceso a Fincas",
    chooseTheUserYouWantToManageFarmAccessFor: "Elija el (los) usuario(s) para el (los) cual(es) desea gestionar el acceso a la finca.",
    selectTheFarmYouWantToManageAccessFor: "Seleccione la finca para la cual desea gestionar el acceso.",
    proceedWithSelected: "Continuar con seleccionado",
    userRole: "Rol de Usuario",
    userRoleInfo: "Rol de usuario. El rol de usuario determina los permisos que el usuario tiene en la finca.",
    usersSelected: "usuarios seleccionados",
    viewFarmAccess: "Ver Acceso a la Finca",
    selectUser: "Seleccionar Usuario",
    recordsPerPage: "Registros por página",
    print: "Imprimir",
    custom: "Personalizado",
    records: "Registros",
    dashboard: "Panel de Control",
    accessControl: "Control de Acceso",
    all: "Todos",
    farmer: "Agricultor",
    technician: "Técnico",
    userNameAndId: "Nombre e ID de Usuario",
    email: "Correo electrónico",
    userRoleAndRegDate: "Rol de Usuario / Fecha de Registro",
    access: "Acceso",
    active: "Activo",
    inactive: "Inactivo",
    na: "N/A",
    userDeactivated: "Usuario Desactivado",
    userActivated: "Usuario Activado",
    farmUsers: "Usuarios de la Finca",
    viewAndUpdateTheFarmsThisUserHasAccessTo: "Ver y actualizar las fincas a las que este usuario tiene acceso",
    assignFarmsToTheSelectedUsers: "Asignar fincas a los usuarios seleccionados",
    selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Seleccione las fincas a las que desea conceder acceso para los técnicos elegidos.",
    removeAccessFromSelectedFarms: "Eliminar Acceso de las Fincas Seleccionadas",
    grantFarmAccess: "Conceder Acceso a la Finca",
    back: "Atrás",
    s: "(s)",
    loadingData: "Cargando datos...",
    areYouSureYouWantToGrantAccessTo: "¿Está seguro de que desea conceder acceso a",
    areYouSureYouWantToRemoveAccessFrom: "¿Está seguro de que desea eliminar el acceso de",
    farmAccessRemoved: "Acceso a la Finca Eliminado",
    successfullyRemovedAccessFrom: "Acceso eliminado con éxito de",
    failedToRemoveFarmAccessPleaseTryAgain: "Error al eliminar el acceso a la finca. Por favor, intente nuevamente.",
    forTheFollowingUsers: "para el (los) siguiente(s) usuario(s)?",
    selectFarm: "Seleccionar Finca",
    grantAccess: "Conceder Acceso",
    removeAccess: "Eliminar Acceso",
    removeFarmAccess: "Eliminar Acceso a la Finca",
    farmAccessGranted: "Acceso a la Finca Concedido",
    successfullyGrantedAccessTo: "Acceso concedido con éxito a",
    farm: "finca",
    for: "para",
    user: "usuario",
    failedToGrantFarmAccessPleaseTryAgain: "Error al conceder acceso a la finca. Por favor, intente nuevamente.",
    error: "Error",
    selectFactory: "Seleccionar Fábrica",
    failedToLoadFarmsPleaseTryAgain: "Error al cargar fincas. Por favor, intente nuevamente.",
    farmNameAndId: "Nombre e ID de la Finca",
    farmAddedBy: "Finca agregada por",
    exportAsCSV: "Exportar como CSV",
    activityLog: "Registro de Actividades",


    youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "Ha compartido el acceso de la finca con el (los) siguiente(s) usuario(s) con éxito.",
    grantAccessToMoreUsers: "Conceder Acceso a Más Usuarios",
    areYouSureYouWantToRemoveAccessFor: "¿Está seguro de que desea eliminar el acceso para",
    thisUser: "este usuario",
    areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "¿Está seguro de que desea conceder acceso a esta finca para el (los) siguiente(s) usuario(s)?",
    failedToLoadUsersPleaseTryAgain: "Error al cargar usuarios. Por favor, intente nuevamente.",
    successfullyRemovedUserAccessFromThisFarm: "Acceso del usuario eliminado con éxito de esta finca.",
    farmIdAndUserIdAreRequired: "Se requieren el ID de la Finca y el ID del Usuario.",
    noUsersSelectedPleaseSelectAtLeastOneUser: "No se seleccionaron usuarios. Por favor, seleccione al menos un usuario.",
    successfullyGrantedAccessToThisFarmFor: "Acceso concedido con éxito a esta finca para",
    unknownUser: "Usuario Desconocido",
    confirm: "CONFIRMAR",
    farmActivityLog: "Registro de Actividades de la Finca",
    ipAddress: "Dirección IP",
    dateAndTime: "Fecha y Hora",
    module: "Módulo",
    activityDescription: "Descripción de la Actividad",
    select: "Seleccionar",

    addNewUsers: "Agregar Nuevos Usuarios",
    addUsersToFarm: "Agregar Usuarios a la Finca",
    selectedUsers: "Usuarios Seleccionados",
    selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Seleccione los usuarios para agregar a la finca de la lista a continuación de todos los usuarios de una cooperativa.",
    reviewTheSelectedUsersAndAssignTheirAccessRoles: "Revise los usuarios seleccionados y asigne sus roles de acceso.",
    allRoles: "Todos los Roles",
    userRegistrationDate: "Fecha de Registro del Usuario",
    deactivated: "Desactivado",
    pleaseSelectAtLeastOneUser: "Por favor, seleccione al menos un usuario",
    noUsersSelected: "No se seleccionaron usuarios",
    userRemoved: "Usuario eliminado",
    next: "SIGUIENTE",
  },

  farm_upload_validation: {
    Farm_Upload_Validation: "Validación de Carga de la Granja",
    Bulk_Upload_Field_Validation: "Validación de Campos de Carga Masiva",
    Go_Back: "Regresar",
    Input_Field: "Campo de Entrada",
    Validation_Message: "Mensaje de Validación",
    Description: "Descripción",
    Action: "Acción",
    Validate: "Validar",
    Farm_Name: "Nombre de la Granja",
    Farm_Registration_ID: "ID de Registro de la Granja",
    Farmer_First_Name: "Nombre del Agricultor",
    Farmer_Last_Name: "Apellido del Agricultor",
    Farmer_Registration_ID: "ID de Registro del Agricultor",
    User_Email_Address: "Dirección de Correo Electrónico del Usuario",
    Shared_Access_With: "Compartir Acceso Con",
    Ownership_Type: "Tipo de Propiedad",
    Goal_s: "Objetivo(s)",
    Production_Type: "Tipo de Producción",
    Certifications: "Certificaciones",
    Total_Farm_Size: "Tamaño Total de la Granja (por ejemplo, 50 acres o 20 hectáreas)",
    Farm_Address: "Dirección de la Granja",
    Farm_GPS_Coordinates: "Coordenadas GPS de la Granja (por ejemplo, 40.7128, -74.0060)",
    Country: "País",
    Province_State: "Provincia/Estado",
    Village_Town_City: "Pueblo/Ciudad",
    Farm_Geofence: "Geovalla de la Granja (Polígono o Círculo)",
    Helper_Messages: {
      Farm_Name: {
        Description: "El nombre oficial de la granja registrado ante las autoridades o conocido públicamente.",
        Usage: "Este nombre se utiliza para identificación y branding."
      },
      Farm_Registration_ID: {
        Description: "Un identificador único para el registro de la granja.",
        Assignment: "Asignado por un organismo gubernamental o agrícola."
      },
      Farmer_First_Name: {
        Description: "El nombre del agricultor que posee o explota la granja.",
        Usage: "Se utiliza para identificación personal y documentación legal.",
        Instructions_1: "Ingrese el nombre del agricultor.",
        Instructions_2: "Evite abreviaturas, números o caracteres especiales.",
        Instructions_3: "Si se deja en blanco, el sistema generará automáticamente 'Desconocido' como nombre."
      },
      Farmer_Last_Name: {
        Description: "El apellido del agricultor.",
        Usage: "Se utiliza para identificación personal y documentación legal.",
        Instructions_1: "Ingrese el apellido del agricultor.",
        Instructions_2: "Evite abreviaturas, números o caracteres especiales.",
        Instructions_3: "Verifique que el apellido esté incluido y correctamente formateado.",
        Instructions_4: "Si se deja en blanco, el sistema generará automáticamente 'Desconocido' como apellido."
      },
      Farmer_Registration_ID: {
        Description: "Un identificador único para el registro del agricultor.",
        Assignment: "Generalmente asignado por un organismo regulador o agrícola.",
        Usage: "Se utiliza para registro formal y cumplimiento.",
        Instructions_1: "Ingrese el ID de registro del agricultor para evitar duplicados.",
        Instructions_2: "Asegúrese de que sea único y esté correctamente formateado.",
        Instructions_3: "Si se deja en blanco, el sistema le pedirá que lo proporcione para evitar crear entradas duplicadas (no obligatorio)."
      },
      User_Email_Address: {
        Description: "Este es un correo electrónico de un usuario que será asignado a la granja o tendrá acceso principal a la granja.",
        Context: "Esto podría ser un agricultor o un técnico.",
        Usage: "Este correo electrónico se utiliza para comunicación, notificaciones y gestión de cuentas.",
        Instructions_1: "Ingrese un correo electrónico válido (por ejemplo, ejemplo@dominio.com).",
        Instructions_2: "Verifique errores tipográficos y espacios.",
        Instructions_3: "Verifique que el formato del correo electrónico sea correcto.",
        Instructions_4: "Si se deja en blanco, el sistema debería pedir al usuario que proporcione un correo electrónico válido (no obligatorio)."
      },
      Shared_Access_With: {
        Description: "Especifica las personas o entidades con las que se comparte el acceso a los datos de la granja.",
        Usage: "Permite una colaboración controlada basada en roles y responsabilidades."
      },
      Ownership_Type: {
        Description: "Indica el tipo de propiedad de la granja.",
        Examples: "Ejemplos incluyen individual, sociedad o corporación.",
        Usage: "Se utiliza para fines legales y administrativos."
      },
      Goal_s: {
        Description: "Describe los objetivos principales de la granja."
      },
      Production_Type: {
        Description: "Indica la actividad agrícola principal de la granja, como orgánica o convencional."
      },
      Certifications: {
        Description: "Seleccione las certificaciones relacionadas con la granja, como certificación orgánica, comercio justo o GAP."
      },
      Total_Farm_Size: {
        Description: "Área total de la granja (acres o hectáreas). Se utiliza para la planificación de recursos, informes regulatorios y análisis de mercado."
      },
      Farm_Address: {
        Description: "Ingrese la dirección completa de la granja, incluyendo dirección de la calle, ciudad, estado y código postal. Se utiliza para identificación de ubicación y entrega de servicios."
      },
      Farm_GPS_Coordinates: {
        Description: "Coordenadas geográficas (latitud y longitud) de la ubicación de la granja. Ayuda a localizar la granja en un mapa."
      },
      Country: {
        Description: "El país donde se encuentra la granja."
      },
      Province_State: {
        Description: "La provincia o estado donde se encuentra la granja. Las opciones dependen del país seleccionado."
      },
      Village_Town_City: {
        Description: "El pueblo, ciudad o municipio donde se encuentra la granja."
      },
      Farm_Geofence: {
        Description: "La cartografía de geovalla de la granja incluye los límites de la granja en un mapa. Define el límite de la granja utilizando una geovalla (polígono o círculo)."
      }
    },
    validation: {
      farmNameRequired: "El nombre de la granja es obligatorio",
      farmNameMaxLength: "El nombre de la granja debe tener menos de 50 caracteres",
      farmNameExists: "El nombre de la granja ya existe",
      registrationIDRequired: "El ID de registro es obligatorio",
      registrationIDMaxLength: "El ID de registro debe tener menos de 20 caracteres",
      firstNameRequired: "El nombre del agricultor es obligatorio",
      firstNameLettersOnly: "El nombre debe contener solo letras",
      lastNameRequired: "El apellido del agricultor es obligatorio",
      lastNameLettersOnly: "El apellido debe contener solo letras",
      emailRequired: "El correo electrónico es obligatorio",
      emailValid: "Ingrese un correo electrónico válido (por ejemplo, ejemplo@dominio.com)",
      emailNoSpaces: "El correo electrónico no debe contener espacios",
      sharedAccessWithRequired: "Seleccione al menos una entidad o deje en blanco",
      ownershipTypeRequired: 'El tipo de propiedad es obligatorio o será por defecto "Desconocido"',
      farmGoalsMaxLength: "Los objetivos de la granja deben tener menos de 500 caracteres",
      productionTypeRequired: "Seleccione un tipo de producción o deje en blanco",
      certificationsRequired: "Seleccione al menos una entidad o deje en blanco",
      farmSizePositive: "El tamaño de la granja debe ser un valor numérico positivo",
      farmSizeUnit: "Especifique la unidad (por ejemplo, 50 acres o 20 hectáreas)",
      farmAddressFormat: "Dirección inválida. Formato: Calle, Ciudad, Estado, Código Postal",
      farmGPSCoordinatesFormat: "Coordenadas GPS inválidas. Formato: Latitud, Longitud (por ejemplo, 40.7128, -74.0060)",
      countryRequired: "El país es obligatorio",
      countryLettersOnly: "El nombre del país debe contener solo letras",
      provinceStateRequired: "La provincia/estado es obligatorio",
      provinceStateLettersOnly: "La provincia/estado debe contener solo letras",
      villageTownCityRequired: "El pueblo/ciudad es obligatorio",
      villageTownCityLettersOnly: "El pueblo/ciudad debe contener solo letras",
      farmGeofencePolygon: "Puntos de polígono inválidos. Formato: Pares de latitud, longitud",
      farmGeofenceCircle: "Geovalla inválida. Formato: Latitud, Longitud del centro; Área en hectáreas"
    }
  },

  plantation: {
    farmerName: "Nombre del granjero",
    phoneNumber: "Número de teléfono",
    plantationName: "Nombre de la plantación",
    farm: "Finca",
    location: "ubicación",
    updatePlantationStatus: "Actualizar situación de la plantación",
    update: "Actualizar",
  },
}